import { DELETE_USER, STATUS, USER_INFO } from "../constans";

const initState = {
  status: null,
  info: {
    name: "",
    email: "",
    role: "",
    phone: "",
    company: "",
    newUser: false,
  },
};
const authReducer = (state = initState, { type, payload }) => {
  switch (type) {
    case STATUS:
      return {
        ...state,
        status: payload,
      };
    case USER_INFO:
      return {
        ...state,
        info: payload,
      };
    case DELETE_USER:
      return initState;
    default:
      return state;
  }
};
export default authReducer;
